<template>
  <div>
    <div class="detailtitle">
      <div class="leticon"></div>
      <div class="titletxt">发票信息</div>
    </div>
    <div class="infotwo">
      <div class="infoitem">
        <div class="infotitle">近12个月平均交易月份数</div>
        <div class="infovalue">{{ detail.invoiceInfoPrompt.avgTradeMonth }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">前十大客户开票金额占比</div>
        <div class="infovalue">{{ detail.invoiceInfoPrompt.custMax10AmtRatio12mon }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近12个月综合费用开票金额</div>
        <div class="infovalue">{{ detail.invoiceInfoPrompt.expenseTotalAmount12Month }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">核心客户销售金额同比</div>
        <div class="infovalue">{{ detail.invoiceInfoPrompt.headCustomer12MonthTB }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">涉及关联交易的核心客户数量</div>
        <div class="infovalue">{{ detail.invoiceInfoPrompt.headCustomerNum }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">进项最早开票距今月份数</div>
        <div class="infovalue">{{ detail.invoiceInfoPrompt.incomeMaxMonths }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近3月开票金额环比</div>
        <div class="infovalue">{{ detail.invoiceInfoPrompt.invSalesAmtHb3m }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近24个月未开票月份数</div>
        <div class="infovalue">{{ detail.invoiceInfoPrompt.invSalesNullCnt24m }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">最晚一次开票距今天数</div>
        <div class="infovalue">{{ detail.invoiceInfoPrompt.latestInvoiceDay }}</div>
      </div>

      <div class="infoitem">
        <div class="infotitle">最大客户销售占比</div>
        <div class="infovalue">{{ detail.invoiceInfoPrompt.maxSalesCustomerRate }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近12个月最大供应商开票总额</div>
        <div class="infovalue">{{ detail.invoiceInfoPrompt.maxSupplierAmountRec12Mon }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近12个月未开票月份数</div>
        <div class="infovalue">{{ detail.invoiceInfoPrompt.noSalesRec12Mon }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">冲红作废比例（近6个月）</div>
        <div class="infovalue">{{ detail.invoiceInfoPrompt.rateNegativeVoided }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">开票金额同比（近12个月）</div>
        <div class="infovalue">{{ detail.invoiceInfoPrompt.rec3MonthTb }} </div>
      </div>
      <div class="infoitem">
        <div class="infotitle">开票金额同比（近6个月）</div>
        <div class="infovalue">{{ detail.invoiceInfoPrompt.rec6MonthTb }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近12个月开票最大间隔天数</div>
        <div class="infovalue">{{ detail.invoiceInfoPrompt.salesGapDaysMax12mon }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近12个月作废票张数</div>
        <div class="infovalue">{{ detail.invoiceInfoPrompt.salesInvalidCnt12mon }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近12个月红冲票张数</div>
        <div class="infovalue">{{ detail.invoiceInfoPrompt.salesNegativeCnt12mon }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近12个月红冲作废发票金额</div>
        <div class="infovalue">{{ detail.invoiceInfoPrompt.voidNegativeAmount12Mon }}</div>
      </div>

      <div class="infoitem">
        <div class="infotitle">近12个月发票冲红作废占比</div>
        <div class="infovalue">{{ detail.invoiceInfoPrompt.voidNegativeRate12Mon }}</div>
      </div>
      <div class="infoitem">
        <div class="infotitle">近12个月无效开票月份</div>
        <div class="infovalue">{{ detail.invoiceInfoPrompt.voidSalesCount12Month }}</div>
      </div>
    </div>
    <van-cell title="最高月度开票金额占开票总金额比例（近12个月）" :label="detail.invoiceInfoPrompt.max12MonthAmountRate" :border="false" />
    <van-cell title="近12个月红冲作废发票金额占比" :label="detail.invoiceInfoPrompt.voidNegativeAmountRate12Mon" :border="false" />
    <van-cell title="近12个月红冲作废发票张数占比" :label="detail.invoiceInfoPrompt.voidNegativeCountRate12Mon" :border="false" />
    <van-cell title="有效票按季度汇总" :border="false" />
    <div class="datatable tableinfo2" style="margin-top: 0;">
      <div class="dataitem datahead">
        <div class="datacell">年份</div>
        <div class="datacell">季度</div>
        <div class="datacell">季度金额合计</div>
        <div class="datacell">季度金额合计同比</div>
      </div>
      <div class="dataitem" :key="index" v-for="(item, index) in detail.customerQuarter">
        <div class="datacell">{{ item.yearName }}</div>
        <div class="datacell">{{ item.quarter }}</div>
        <div class="datacell">{{ item.invSalesAmt }}</div>
        <div class="datacell">{{ item.invSalesAmtTb }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object
    },
  }
}
</script>

<style></style>